import React, {useState, useRef, useEffect, Fragment} from 'react';
import { ExportExcelButton, ImportExcelButton, dataCheck, sheet } from '../../lib/excel'
import FieldDropdown from '../FieldDropdown';
import { errorAlert, slugify, successAlert } from '../../lib/utils'
import SchemaProducts from '../../sanity_ecommerce/schemas/product'
import { v4 as uuidv4 } from 'uuid';
import { useStateContext } from '../../context/StateContext';
import { keyId } from '../../lib/utils';
import { referenceDoc } from '../gestioneDatabase/Docs';
import VisDiv from '../frontend_components/VisDiv';
import PromiseQueue from 'p-queue'
import { useCreateReplace, useDeleteDocument } from '../../hooks/mutations';
import { useQueryClient } from '@tanstack/react-query';
import { TiDelete } from 'react-icons/ti';
import { sortByName, addValueForDropdown } from '../../lib/utils';
import SearchField from '../SearchField';
import { yesNoAlert } from '../../lib/utils';
import TrueFalseToggle from '../TrueFalseToggle';
import Divider from '../frontend_components/Divider';
import {FiSave} from 'react-icons/fi'


const ProdottiFornitori = ({data={}}) => {


    const {suppliers, products} = data
    const {
        excelData,
        setExcelData,
    } = useStateContext();

    const [searchValue, setSearchValue] = useState("");
    const [filterPriceZero, setFilterPriceZero] = useState(false);
    const searchRef = useRef();

    const {mutate: updateCreateDocument} = useCreateReplace({
        onError:()=>{errorAlert("Errore: il documento non é stato aggiornato")}
    
    })

    const supplierProductsDoc = (item) => ({
        _type: "product",
        _id: item?.supplierProductId ? item?.supplierProductId : uuidv4(),
        name: item?.name,
        price: item?.price,
        productCode: item?.productCode?.trim(),
        supplier: referenceDoc(item?.supplierId),
        slug:{_type:"slug", current: slugify(item?.name, true)}
    })
    const supplierProductDocs = !Array.isArray(excelData) ? [] : excelData?.map?.((item)=>(supplierProductsDoc(item)))
    const supplierProductsToImport = !Array.isArray(supplierProductDocs) ? [] : supplierProductDocs?.filter?.((x)=>x?.supplier?._ref && x?.price)

    const createUpdateDocuments = async (docs) => {
        
        const queue = new PromiseQueue({
          concurrency: 12,
          intervalCap: 15,
          interval: 700,
        })
        for(const doc of docs) {
            //console.log("Document tested:", doc)
             queue.add(() => {
                return updateCreateDocument({doc: doc})
              })
        }      
  }

    const testFunction = () => {
        //console.log("prodotti fornitori", supplierProductsToImport)
        //console.log("excelData", excelData)
        //console.log("no supplier", supplierProductDocs?.filter?.((x)=>!x?.supplier?._ref && !x?.price))

        //console.log("no slug", products?.filter?.((x)=>!x?.slug))
        //console.log("no price", products?.filter?.((x)=>!x?.price && x?.price != 0))
        //console.log(slugify("test con TOKEN", true))


        

    }

    const productsData = products?.map?.((product)=>{

        //const listProduct = listProducts?.find?.((x)=>product?._id == x?.customerProduct?._ref )
        return({
            supplierProductId: product?._id, 
            name: product?.name, 
            price: product?.price, 
            productCode: product?.productCode,
            supplierId: product?.supplier?._ref,    
      })})

      const suppliersData = suppliers?.map?.((supplier)=>{

        //const listProduct = listProducts?.find?.((x)=>product?._id == x?.customerProduct?._ref )
        return({
            name: supplier?.name,
            _id: supplier?._id
      })})
      const mainSheet = sheet(productsData ,"PRODOTTI")
      const secondSheet = sheet(suppliersData, "FORNITORI")
      
    
    const sheets = [mainSheet, secondSheet]
    const importedData = (excelData) => {
        setExcelData(excelData)
        //console.log("IMPORT EXCEL", data)

        const workedData = excelData?.map?.((item)=>(supplierProductsDoc(item)))
    
        const dataCheckDoc = {excelData: workedData, type:"product", schema: SchemaProducts}
        const dataConforms = dataCheck(dataCheckDoc)
        console.log("CHECK PASSED",dataConforms)
        const findKey = () => {
            const findPriceListKey = !Array.isArray(customer?.priceLists) ? undefined : customer?.priceLists?.find?.(x=>x?._id == priceList?._id)?._key
            return(findPriceListKey)
          }
        const doc = {
            ...priceList,
            products: workedData
        }
        
        if(dataConforms){
            console.log("BEGIN UPDATE")
            const queryDoc = {
                id: customer?._id, 
                //key: findKey(),
                doc,
            }  
        console.log("QUERY DOC:", queryDoc)

/*         replacePriceList(queryDoc,{
            onSuccess:()=>{
                console.log("Document Updated Successfully");
                const newCustomerDoc = {
                    ...customer,
                    priceLists: [...customer?.priceLists?.filter?.((x)=>x?._key !== doc?._key), doc]
                }
                setCustomer(newCustomerDoc)
        }}) */  
        
    }
    }

    const searchFilter = (x) =>{
        // search-box
      
        const search =  x?.name?.toLowerCase()?.indexOf(searchValue.toLowerCase()) >= 0
        if(filterPriceZero) return search && (x?.price == 0 || !x?.price)
       return search 
    }
       //search-box
       const onSearchClick = (e) => {
        e.stopPropagation()
      };
      const onSearch = (e) => {
        setSearchValue(e.target.value);
      };

  return (
    <div className='new-device-container' >
        <h2>PRODOTTI FORNITORI</h2>
        <VisDiv style={{marginBottom:"15px"}} rules={[true]}>
            <button onClick={testFunction}>NO SLUG AND NO PRICE DATA IN CONSOLE</button>
        </VisDiv>
        <VisDiv rules={[false]}>

    
            <ExportExcelButton sheets={sheets} title={`PRODOTTI FORNITORI`} /> 
            <ImportExcelButton returnedData = {importedData} />

            <VisDiv style={{marginTop:"15px"}} rules={[true]}>
                <button onClick={()=>createUpdateDocuments(supplierProductsToImport)}>UPDATE DOCUMENTS</button>
            </VisDiv>
        </VisDiv>
        <h4>{"FILTRA PRODOTTI PREZZO 0"}:</h4>
        <TrueFalseToggle value={filterPriceZero} onClick={()=>setFilterPriceZero(!filterPriceZero)}/>
        <AddSupplierProduct suppliers={suppliers}/>
        <h4>{"CERCA"}:</h4>
        <div className="search-box" style={{backgroundColor:"white", fontSize:"12px"}}>
            <input onClick={(e)=>onSearchClick(e)} style={{fontSize:"18px"}} onChange={onSearch} value={searchValue} ref={searchRef} />
        </div>
       
        {products?.sort(sortByName)?.filter?.(searchFilter)?.map?.((product, index)=> {
            return(
                <div key={product?._id}>
                    <SupplierProduct product={product} index={index} suppliers={suppliers}/>
                </div>
      
            )
        })}
    </div>
  )
}

export default ProdottiFornitori

//===================================================================



export const SupplierProduct = ({product, index, suppliers}) => {
    const rowColour = index % 2 ? "white":"#e6e6e6"
    const queryClient = useQueryClient()
    const [supplierProduct, setSupplierProduct] = useState(product)

    
    const {mutate: updateProduct} = useCreateReplace({
            onMutate: async (newDoc) => {        
                const doc = newDoc?.doc  
                await queryClient.cancelQueries({ queryKey: ['product'] })
                const previousPriceLists = queryClient.getQueryData(['product'])   
                queryClient.setQueryData(['product'], (old) =>{ 
                    const oldData = old?.length > 0 ? old : []
                    const newData = [...oldData?.filter?.(x=>x?._id!==doc?._id), doc]
                    return newData
                })
                
                return { previousPriceLists }
            }, 
            onError: (err, newDoc, context) => {
                errorAlert("Errore: il prodotto non é stato aggiornato")
        /*         queryClient.setQueryData(['registers', site], context?.previousRegisters)
                setRegisters(context.previousRegisters)
                setRegister(context.register)
                updateDevices(devices, setDevices, device, context?.device) */
                console.error('Oh no, the update failed: ', err?.message)}
            })

            const {mutate: deleteProduct} = useDeleteDocument({
                onMutate: async (newDoc) => {          
                    await queryClient.cancelQueries({ queryKey: ['product'] })
                    const previousPriceLists = queryClient.getQueryData(['product'])   
                    const doc = newDoc?.doc  
                    queryClient.setQueryData(['product'], (old) =>{ 
                        const oldData = old?.length > 0 ? old : []
                        const newData = [...oldData?.filter?.(x=>x?._id!==newDoc?.documentId)]
                        return newData
                    })
                    
                    return { previousPriceLists }
                }, 
                onError: (err, newDoc, context) => {
                    errorAlert("Errore: il prodotto non é stato eliminato")
            /*         queryClient.setQueryData(['registers', site], context?.previousRegisters)
                    setRegisters(context.previousRegisters)
                    setRegister(context.register)
                    updateDevices(devices, setDevices, device, context?.device) */
                    console.error('Oh no, the update failed: ', err?.message)}
                })

            const deleteLine = () =>{
                console.log("DELETE LINE")
                const queryDoc = {
                    doc: product, 
                    documentId: product?._id
                }
                yesNoAlert( ()=>deleteProduct(queryDoc), `VUOI ELIMINARE ${supplierProduct?.name}?`)
               
            }

            const save = () => {
                const queryDoc = {
                    doc:  {...supplierProduct, price: Number(supplierProduct?.price)},
                }
                    updateProduct(queryDoc)
              
                //console.log("SAVE", priceProduct, priceList, queryDoc)

            }

            const expandSupplier = (supplierReference) => {
                const findSupplier = !Array.isArray(suppliers) ? {} : suppliers?.find?.((x)=>supplierReference?._ref == x?._id)
                return (
                    {
                        ...findSupplier,
                        value: findSupplier?.name, 
                        label:findSupplier?.name
                    }
                )
            }
return (
<div style={{backgroundColor:rowColour, padding:"10px", display:"flex", justifyContent:"space-evenly", alignItems:"center"}}>
    <VisDiv style={{marginRight:"10px"}}>
        <button
            type="button"
            className="remove-item"
            onClick={() => deleteLine()}
            >
            <TiDelete />
        </button>
    </VisDiv>
    <div style={{flex: 1}}><input onBlur={save} className="emptyInputText" type="text" placeHolder={"Cod. Prod. For."} value={supplierProduct?.productCode} onChange={(e) => {setSupplierProduct({...supplierProduct, productCode:e.target.value});}}/></div>
    <div style={{flex: 2, marginRight:"10px"}}>
    <FieldDropdown
            sorted={true}
            isSearchable="isSearchable"
            initialValue={expandSupplier(supplierProduct?.supplier)}
            placeHolder={"ASSEGNA PRODOTTO INTERNO"}
            options={suppliers?.map?.((item)=>({...item, value: item?.name, label:item?.name}))}
            onChange={(value) => { 
                const doc = {...supplierProduct, supplier:referenceDoc(value?._id)}
                setSupplierProduct(doc)
                updateProduct({doc})
            }}
        />

    </div>
    <div style={{flex: 4}}><input onBlur={save} className="emptyInputText" type="text" value={supplierProduct?.name} onChange={(e) => {setSupplierProduct({...supplierProduct, name:e.target.value});}}/></div>
    <div style={{flex: 1, display:"flex", alignItems:"center"}}>{"€"}<input onBlur={save} className="emptyInputText" type="number" value={supplierProduct?.price} onChange={(e) => {setSupplierProduct({...supplierProduct, price:e.target.value});}}/></div>

</div>
)
}

//==========================

export const AddSupplierProduct = ({suppliers, setNewDocument = ()=>{}}) => {


    const emptyDoc = () => ({
        _type: "product",
        _id: uuidv4(),
        _key: keyId(),
        name: "",
        productCode: "",
        price: Number(0),
        slug: "", 
       supplier:{
           _key: keyId(),
           _type: "reference",
           _ref: ""

       }
   })


    const [supplier, setSupplier] = useState()

    const [supplierProduct, setSupplierProduct] = useState(emptyDoc())
    const queryClient = useQueryClient()

        const {mutate: addNewProduct} = useCreateReplace({
                onMutate: async (newDoc) => {      
                    const doc = newDoc?.doc    
                    await queryClient.cancelQueries({ queryKey: ['product'] })
                    const previousPriceLists = queryClient.getQueryData(['product'])   
                    queryClient.setQueryData(['product'], (old) =>{ 
                        const oldData = old?.length > 0 ? old : []
                        const newData = [...oldData?.filter?.(x=>x?._id!==doc?._id), doc]
                        return newData
                    })
                    
                    return { previousPriceLists }
                }, 
                onError: (err, newDoc, context) => {
                    errorAlert("Errore: il prodotto non é stato aggiunto")
            /*         queryClient.setQueryData(['registers', site], context?.previousRegisters)
                    setRegisters(context.previousRegisters)
                    setRegister(context.register)
                    updateDevices(devices, setDevices, device, context?.device) */
                    console.error('Oh no, the update failed: ', err?.message)}
                })

            const save = () => {

                const queryDoc = {
                    doc: {...supplierProduct, price: Number(supplierProduct?.price), slug:{_type:"slug", current: slugify(supplierProduct?.name, true)}},
                }
                if(!queryDoc?.doc?.supplier?._ref){
                    errorAlert("Inserire Il fornitore")
                    return
                }
            
                addNewProduct(queryDoc,{
                    onSuccess:()=>{
                        setSupplierProduct(emptyDoc())
                        setSupplier({}) 
                        setNewDocument(queryDoc?.doc)
                    }
                })    
                console.log("SAVE", supplierProduct, queryDoc)
            

            }
            const expandedSupplierDoc = (supplier) => ({
                ...supplier,
                value: supplier?.name, 
                label:supplier?.name
            })
return (
<>
<h4>AGGIUNGI PRODOTTO:</h4>
<div style={{backgroundColor:"white", padding:"10px", display:"flex", justifyContent:"space-evenly", alignItems:"center"}}>

    <div style={{flex: 2, marginRight: "10px"}}><input placeholder='CODICE PRODOTTO FORNITORE' className='text-input' type="text" value={supplierProduct?.productCode} onChange={(e) => {setSupplierProduct({...supplierProduct, productCode:e.target.value});}}/></div>
    <div style={{flex: 4, marginRight: "10px"}}><input placeholder='NOME PRODOTTO' className="text-input" type="text" value={supplierProduct?.name} onChange={(e) => {setSupplierProduct({...supplierProduct, name:e.target.value});}}/></div>
    <div style={{flex: 4, marginRight: "15px"}}>                         
        <FieldDropdown
            sorted={true}
            isSearchable="isSearchable"
            initialValue={supplier}
            placeHolder={"ASSEGNA FORNITORE"}
            options={suppliers?.map?.((x)=>expandedSupplierDoc(x))}
            onChange={(value) => { 
                setSupplier(value)
                setSupplierProduct({
                    ...supplierProduct,
                    supplier: referenceDoc(value?._id),
                })
            }}
        />
    </div>
    <div style={{flex: 1, display:"flex", alignItems:"center"}}>{`€ `}<input placeholder={0} className="text-input" inputMode="numeric" type="number" value={supplierProduct?.price} onChange={(e) => {setSupplierProduct({...supplierProduct, price:e.target.value});}}/></div>
    <VisDiv rules={[true]}>
        <button type='button' className='round-back-button' style={{backgroundColor:"green", marginLeft:"10px"}} onClick={save}>
            <FiSave            
                size={15}
                color={"white"}/>
        </button>
    </VisDiv>
{/*     <VisDiv style={{color:"darkBlue", cursor:"pointer", marginLeft:"10px"}} >
        <VisDiv className='round-back-button' style={{backgroundColor:"white"}} onClick={save}> 
            <IoIosAddCircleOutline fontSize={30} />
        </VisDiv>
    </VisDiv> */}
</div>
<Divider bottom={"15px"}/>
</>
)
}